import React from 'react';

/**
 * JSON-LD yapılandırılmış veri şemalarını sayfaya ekleyen bileşen
 * @param {object} schema - Eklenecek JSON-LD şeması
 */
export default function JsonLd({ schema }: { schema: Record<string, any> }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
} 